import { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";

import styles from "./KMarkdown.module.scss";

declare namespace KMarkdown {
  type Props = Omit<React.ComponentProps<typeof Markdown>, "children"> & {
    children: string;
    typewriter?: boolean;
  };
}

export default KMarkdown;
function KMarkdown({
  children: markdown,
  typewriter = false,
  ...props
}: KMarkdown.Props) {
  const [markdownLength, setMarkdownLength] = useState(
    typewriter ? 0 : markdown.length
  );

  useEffect(() => {
    if (typewriter && markdownLength < markdown.length) {
      const addMarkdown = setTimeout(() => {
        setMarkdownLength((prev) => prev + 15);
      }, 50);

      return () => {
        clearTimeout(addMarkdown);
      };
    }
  }, [typewriter, markdownLength, markdown]);

  return (
    <Markdown {...props} className={styles["markdown"]}>
      {markdown.slice(0, markdownLength)}
    </Markdown>
  );
}
